import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  faEnvelope,
  faPhoneAlt,
  faClock,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faTwitter,
  faLinkedinIn,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logo from "../assets/img/logo1.png";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Helper: active route style
  const isActive = (path) =>
    location.pathname === path
      ? { color: "var(--primary)" }
      : { color: "var(--dark)" };

  return (
    <header
      className="container-fluid px-0 fixed-top"
      style={{
        transition: "all 0.4s ease",
        backgroundColor: scrolled ? "var(--white)" : "transparent",
        boxShadow: scrolled ? "0 2px 10px rgba(0,0,0,0.1)" : "none",
      }}
    >
      {/* ===== Top Bar ===== */}
      <div
        className={`top-bar row gx-0 align-items-center d-none d-lg-flex ${
          scrolled ? "opacity-0 invisible" : "opacity-100 visible"
        }`}
        style={{
          height: scrolled ? "0" : "40px",
          transition: "all 0.4s ease",
          color: "var(--dark)",
          backgroundColor: "var(--light-bg)",
        }}
      >
        <div className="col-lg-6 px-5 text-start">
          <small>
            <FontAwesomeIcon
              icon={faMapMarkerAlt}
              className="me-2"
              style={{ color: "var(--primary)" }}
            />
            Gurgaon , Haryana
          </small>
          <small className="ms-4">
            <FontAwesomeIcon
              icon={faClock}
              className="me-2"
              style={{ color: "var(--primary)" }}
            />
            10.00 am - 6.00 pm
          </small>
        </div>
        <div className="col-lg-6 px-5 text-end">
          <small>
            <FontAwesomeIcon
              icon={faEnvelope}
              className="me-2"
              style={{ color: "var(--primary)" }}
            />
            contact@sagfinancials.com
          </small>
          <small className="ms-4">
            <FontAwesomeIcon
              icon={faPhoneAlt}
              className="me-2"
              style={{ color: "var(--primary)" }}
            />
            +91 7011468336
          </small>
        </div>
      </div>

      {/* ===== Navbar ===== */}
      <nav className="navbar navbar-expand-lg py-1 px-lg-5">
        {/* Logo */}
        <Link to="/" className="navbar-brand d-flex align-items-center ms-3">
          <img
            src={logo}
            alt="SAG Financials Logo"
            className="me-2"
            style={{ height: "70px", width: "auto", objectFit: "contain" }}
          />
          <h1
            className="m-0 fw-bold d-none d-md-block"
            style={{
              color: "var(--primary)",
              fontSize: "1.8rem",
              transition: "color 0.3s ease",
            }}
          >
            SAG Financials
          </h1>
        </Link>

        {/* Toggler */}
        <button
          className="navbar-toggler me-3"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarCollapse"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navigation Links */}
        <div className="collapse navbar-collapse" id="navbarCollapse">
          <div className="navbar-nav ms-auto p-4 p-lg-0">
            {["Home", "About", "Services", "Contact Us"].map((item, i) => {
              const path = item === "Home" ? "/" : `/${item.toLowerCase()}`;
              return (
                <Link
                  key={i}
                  to={path}
                  className="nav-item nav-link"
                  style={{
                    ...isActive(path),
                    fontWeight: 500,
                    transition: "color 0.3s ease",
                  }}
                >
                  {item}
                </Link>
              );
            })}

            {/* Dropdown */}
            <div className="nav-item dropdown">
              <Link
                to="#"
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                style={{ fontWeight: 500, color: "var(--dark)" }}
              >
              More              
              </Link>
              <div className="dropdown-menu border-0 shadow-sm">
                {["IndustriesWeServe", "Our Approach", "Resources", "Testimonial"].map(
                  (page, i) => {
                    const path = `/${page.toLowerCase().replace(" ", "")}`;
                    return (
                      <Link
                        key={i}
                        to={path}
                        className="dropdown-item"
                        style={{
                          color:
                            location.pathname === path
                              ? "var(--primary)"
                              : "var(--dark)",
                        }}
                      >
                        {page}
                      </Link>
                    );
                  }
                )}
              </div>
            </div>
          </div>

          {/* Social Icons */}
          <div className="d-none d-lg-flex ms-3">
            <a
              href="https://www.facebook.com/share/1D2BYZrbo8/"
              className="social-btn ms-2"
              style={{
                color: "var(--primary)",
                backgroundColor: "var(--light-bg)",
                borderRadius: "50%",
                padding: "8px 10px",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "var(--secondary)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "var(--light-bg)")
              }
            >
              <FontAwesomeIcon icon={faFacebookF} />
            </a>
            <a
              href="https://www.instagram.com/finance.with.shepra/"
              className="social-btn ms-2"
              style={{
                color: "var(--primary)",
                backgroundColor: "var(--light-bg)",
                borderRadius: "50%",
                padding: "8px 10px",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "var(--secondary)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "var(--light-bg)")
              }
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a
              href="https://www.linkedin.com/company/sag-financials/"
              target="_blank"
              className="social-btn ms-2"
              style={{
                color: "var(--primary)",
                backgroundColor: "var(--light-bg)",
                borderRadius: "50%",
                padding: "8px 10px",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "var(--secondary)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "var(--light-bg)")
              }
            >
              <FontAwesomeIcon icon={faLinkedinIn} />
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
